type ClearNullish<T> =
  T extends Array<infer U>
    ? Array<ClearNullish<NonNullable<U>>>
    : T extends object
      ? { [K in keyof T]?: ClearNullish<NonNullable<T[K]>> }
      : T;

export function clearNullishProperties<T>(obj: T[]): Array<ClearNullish<NonNullable<T>>>;
export function clearNullishProperties<T extends object>(obj: T): ClearNullish<T>;
export function clearNullishProperties<T>(obj: T): T;
export function clearNullishProperties(obj: unknown): unknown {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) {
    return obj.map((item: unknown) => clearNullishProperties(item)).filter((item: unknown) => item != null);
  }

  const entries: [string, unknown][] = Object.entries(obj).map(([key, value]: [string, unknown]): [string, unknown] => [
    key,
    clearNullishProperties(value),
  ]);

  return Object.fromEntries(entries.filter((entry: [string, unknown]) => entry[1] != null));
}
